module.exports = __webpack_public_path__ + "static/media/project5.481ae891.jpeg";